import {
  CREATE_TICKET_ZAMMAD,
  fileToBase64
} from "../../utils/ZammadServices";
import { getAplicacionValueById } from "../../utils/AplicacionesUtils";

/**
 * Función principal para crear un ticket en Zammad
 * @param {Object} infoFrm - Información del tipo de solicitud
 * @param {Object} dataFrm - Datos del formulario
 * @param {Array} fileUpload - Archivos adjuntos
 * @param {string} userEmail - Email del usuario
 * @param {AxiosInstance} zammadInstance - Instancia autenticada de Zammad
 * @returns {Object} Resultado de la operación
 */
export default async function FnSendRegisterZammad(
  infoFrm,
  dataFrm,
  fileUpload,
  userEmail,
  zammadInstance
) {
  try {
    // PASO 1: Convertir archivos a base64 si existen
    let attachments = [];
    if (fileUpload && fileUpload.length > 0) {
      console.log(`Procesando ${fileUpload.length} archivo(s) adjunto(s)...`);
      attachments = await Promise.all(
        fileUpload.map(async (file) => {
          const base64Data = await fileToBase64(file);
          return {
            filename: file.name,
            data: base64Data,
            'mime-type': file.type || 'application/octet-stream'
          };
        })
      );
    }

    // PASO 2: Convertir el ID de aplicacion_busint al valor string
    const aplicacionBusint = dataFrm.aplicacion_busintLookupId
      ? getAplicacionValueById(dataFrm.aplicacion_busintLookupId)
      : 'posint';

    // PASO 3: Preparar datos del ticket con adjuntos incluidos
    const ticketData = {
      title: dataFrm.Title || `Solicitud de ${infoFrm.Title}`,
      group_id: infoFrm.GrupoZammad || 2,
      customer: userEmail,
      tipo_incidencia: infoFrm.tipo_incidencia || 'soporte_tecnico',
      aplicacion_busint: aplicacionBusint,
      modulo: dataFrm.modulo || aplicacionBusint,
      article: {
        subject: dataFrm.Title || `Solicitud de ${infoFrm.Title}`,
        body: buildTicketBody(dataFrm),
        content_type: "text/html",
        type: "note",
        internal: false,
        attachments: attachments
      }
    };

    // PASO 4: Crear ticket en Zammad con adjuntos incluidos
    console.log('Creando ticket en Zammad con datos:', ticketData);
    const ticketResponse = await CREATE_TICKET_ZAMMAD(zammadInstance, ticketData);
    const ticketId = ticketResponse.data.id;
    const ticketNumber = ticketResponse.data.number;

    console.log(`Ticket creado exitosamente: #${ticketNumber} (ID: ${ticketId})`);

    return {
      success: true,
      ticketId: ticketId,
      ticketNumber: ticketNumber,
      error: null
    };

  } catch (error) {
    console.error('Error al crear ticket en Zammad:', error);

    return {
      success: false,
      ticketId: null,
      ticketNumber: null,
      error: error
    };
  }
}

/**
 * Construir el cuerpo HTML del ticket con los campos del formulario
 * @param {Object} dataFrm - Datos del formulario
 * @returns {string} HTML del cuerpo del ticket
 */
function buildTicketBody(dataFrm) {
  let body = '<div>';

  Object.keys(dataFrm).forEach(key => {
    if (dataFrm[key] !== null && dataFrm[key] !== undefined && dataFrm[key] !== '') {
      const value = dataFrm[key];

      // Formatear valores booleanos
      if (typeof value === 'boolean') {
        body += `<p><strong>${key}:</strong> ${value ? 'Sí' : 'No'}</p>`;
      }
      // Formatear arrays (choices múltiples)
      else if (Array.isArray(value)) {
        body += `<p><strong>${key}:</strong> ${value.join(', ')}</p>`;
      }
      // Otros valores
      else {
        body += `<p><strong>${key}:</strong> ${value}</p>`;
      }
    }
  });

  body += '</div>';
  return body;
}

